var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonReleaseDetails',{staticClass:"inner-container main-pad-y",attrs:{"tabView":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }